import { NavLink } from "react-router-dom";
import { Bell, Database, History, LogOut, Menu, PanelLeftClose, PanelLeftOpen } from "lucide-react";

export default function AdminHeader({ user, collapsed, toggleCollapsed, onOpenMobileNav, onLogout }) {
  return (
    <header className="h-14 flex items-center justify-between px-3 sm:px-4 bg-[#0F1829] text-white border-b border-white/10 sticky top-0 z-20 lg:pl-[80px]">
      <div className="flex items-center gap-2 min-w-0">
        <button onClick={onOpenMobileNav} data-testid="admin-open-nav"
          aria-label="Abrir menu"
          className="lg:hidden p-1 text-white/80 hover:text-white">
          <Menu size={20} />
        </button>
        <button type="button" onClick={toggleCollapsed} data-testid="admin-sidebar-toggle"
          title={collapsed ? "Expandir menu" : "Encolher menu"}
          aria-label={collapsed ? "Expandir menu" : "Encolher menu"}
          className="hidden lg:flex items-center justify-center w-9 h-9 rounded text-white/80 hover:text-white hover:bg-white/10 transition-colors">
          {collapsed ? <PanelLeftOpen size={16} /> : <PanelLeftClose size={16} />}
        </button>
        <div className="w-8 h-8 grid place-items-center rounded bg-[#978D78] text-[#0F1829] shrink-0">
          <Database size={16} />
        </div>
        <div className="leading-tight min-w-0">
          <p className="text-sm font-semibold truncate" style={{ fontFamily: "'Fraunces', serif" }}>IHTP Admin DB</p>
          <p className="text-[10px] uppercase tracking-[0.15em] text-white/50 hidden sm:block">Manutenção</p>
        </div>
      </div>
      <div className="flex items-center gap-2 sm:gap-4">
        <NavLink to="/admin/notifications" data-testid="admin-notifications-link"
          className={({ isActive }) => `text-xs inline-flex items-center gap-1.5 hover:text-[#978D78] ${isActive ? 'text-[#978D78]' : 'text-white/70'}`}>
          <Bell size={14} /> <span className="hidden sm:inline">Notificações</span>
        </NavLink>
        <NavLink to="/admin/audit" data-testid="admin-audit-link"
          className={({ isActive }) => `text-xs inline-flex items-center gap-1.5 hover:text-[#978D78] ${isActive ? 'text-[#978D78]' : 'text-white/70'}`}>
          <History size={14} /> <span className="hidden sm:inline">Log de Auditoria</span>
        </NavLink>
        <span className="text-sm text-white/80 hidden md:inline" data-testid="admin-user-name">
          {user.name || user.email}
        </span>
        <button onClick={onLogout} data-testid="admin-logout-btn"
          className="inline-flex items-center gap-1 text-xs px-2 sm:px-3 py-1.5 rounded bg-white/10 hover:bg-white/20">
          <LogOut size={13} /> <span className="hidden sm:inline">Sair</span>
        </button>
      </div>
    </header>
  );
}
